module.exports = __webpack_public_path__ + "static/media/ca400-video-walkthrough.af3d777.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ca400-video-walkthrough.mp4
// module id = eup0
// module chunks = 0